import { styled } from '@mui/material';
import classNames from 'classnames';

import { ENOPOrganType } from '#shared';

const PREFIX = 'TSMED-AviationTrail';
const aviationTrailClasses = {
  root: `${PREFIX}-root`,
};

const Root = styled('polyline')(({ theme: { palette, mixins } }) => ({
  [`&.${aviationTrailClasses.root}`]: {
    ...mixins.organStyles(palette, { prefix: `&` }),
    fill: 'none',
    stroke: 'black',
    opacity: 0,
    strokeWidth: 3,
    transition: 'opacity 250ms ease-in-out',
    color: 'var(--primaryColor, black)',
    [`&.highlighted`]: {
      stroke: 'currentColor',
      opacity: 1,
    },
  },
}));
interface AviationTrailProps {
  organ: ENOPOrganType | null;
  points: string;
  highlighted?: boolean;
}

export const AviationTrail = ({
  organ,
  points,
  highlighted,
}: AviationTrailProps) => (
  <Root
    className={classNames(aviationTrailClasses.root, {
      highlighted,
      [`organ-type-${organ}`]: !!organ,
    })}
    points={points}
  />
);
